// External libraries
import { createContext } from 'react';

// Types
import { CurrentPageContextType } from '../utils/type';

export const CurrentPageContext = createContext<CurrentPageContextType>({
  currentPage: { pageType: 'Home' },
});
